import { render } from "./cashier_index.vue?vue&type=template&id=23e8d37a&scoped=true"
import script from "./cashier_index.vue?vue&type=script&lang=js"
export * from "./cashier_index.vue?vue&type=script&lang=js"

import "./cashier_index.vue?vue&type=style&index=0&id=23e8d37a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e8d37a"]])

export default __exports__